import GoTop from "./Modules/GoTop";
import Image from "./Modules/Image";
import Carousel from "./Modules/Carousel";
import Question from "./Modules/Question";
import Video from "./Modules/Video";
import Wave from "./Modules/Wave";
import Arc from "./Modules/Arc";
import PageScroll from "./Modules/PageScroll";

!(function () {
    // banner 视频弹窗
    new Video

    // 轮播图
    new Carousel

    // 加载图片
    new Image

    // 返回顶部
    new GoTop
    // 常见问题
    new Question
    // 水波效果
    new Wave('#section-wave')
    new Arc
    new Wave('#footer-wave')
    // 页面滚动
    new PageScroll
})()